import { Injectable } from '@angular/core';
import { SnackbarService } from '../../core/services/snackbar/snackbar.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import {
  applyForReinstatement,
  applyForReinstatementFailed,
  applyForReinstatementReceived,
  cancelPermitRequest,
  cancelPermitRequestFailed,
  getOperatingAuthorityApplicationData,
  getOperatingAuthorityApplicationDataFailed,
  getOperatingAuthorityApplicationDataReceived,
  getOperatingAuthorityApplicationDocumentsData,
  getOperatingAuthorityApplicationDocumentsDataFailed,
  getOperatingAuthorityApplicationDocumentsDataReceived,
  getOperatingAuthorityApplicationFeesData,
  getOperatingAuthorityApplicationFeesDataFailed,
  getOperatingAuthorityApplicationFeesDataReceived,
  getOperatingAuthorityApplicationInvoicesData,
  getOperatingAuthorityApplicationInvoicesDataFailed,
  getOperatingAuthorityApplicationInvoicesDataReceived,
  submitPermitRequest,
  submitPermitRequestFailed,
} from '../actions/operatingAuthorityApplicationAction';
import { OperatingAuthorityApplicationService } from '../../core/services/operatingAuthorityApplication/operating-authority-application.service';
import { noAction } from '../actions/commonAction';

@Injectable()
export class operatingAuthorityApplicationEffect {
  constructor(
    private actions: Actions,
    private OAAService: OperatingAuthorityApplicationService,
    private snackbarService: SnackbarService,
  ) {}
  operatingAuthorityApplicationEffectDetails$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        getOperatingAuthorityApplicationData,
        getOperatingAuthorityApplicationFeesData,
        getOperatingAuthorityApplicationInvoicesData,
        getOperatingAuthorityApplicationDocumentsData,
        submitPermitRequest,
        applyForReinstatement,
        cancelPermitRequest,
      ),
      mergeMap((params) => {
        const userData: any = JSON.parse(
          localStorage.getItem('userData') || '',
        );
        if (params.type === 'get-operating-authority-application') {
          return this.OAAService.getOperatingAuthorityApplicationService(
            userData?.sessionHash,
            params.params,
          ).pipe(
            map((data: any) => {
              const updatedPermitRequestsData = data?.map(
                (permitRequest: any) => ({
                  ...permitRequest,
                  hasMissingCityPermit: permitRequest.hasMissingCityPermit
                    ? 'No'
                    : 'Yes',
                  hasMissingDocuments: permitRequest.hasMissingDocuments
                    ? 'No'
                    : 'Yes',
                  hasMissingInsurance: permitRequest.hasMissingInsurance
                    ? 'No'
                    : 'Yes',
                  hasNoAssignedVehicle: permitRequest.hasNoAssignedVehicle
                    ? 'No'
                    : 'Yes',
                }),
              );
              return getOperatingAuthorityApplicationDataReceived({
                params: updatedPermitRequestsData,
              });
            }),
            catchError((error) =>
              of(getOperatingAuthorityApplicationDataFailed()),
            ),
          );
        } else if (params.type === 'get-operating-authority-application-fees') {
          return this.OAAService.getOperatingAuthorityApplicationFeesService(
            params.params,
          ).pipe(
            map((data: any) => {
              return getOperatingAuthorityApplicationFeesDataReceived({
                params: data,
              });
            }),
            catchError((error) =>
              of(getOperatingAuthorityApplicationFeesDataFailed()),
            ),
          );
        } else if (
          params.type === 'get-operating-authority-application-invoices'
        ) {
          return this.OAAService.getOperatingAuthorityApplicationInvoicesService(
            params.params,
          ).pipe(
            map((data: any) => {
              return getOperatingAuthorityApplicationInvoicesDataReceived({
                params: data,
              });
            }),
            catchError((error) =>
              of(getOperatingAuthorityApplicationInvoicesDataFailed()),
            ),
          );
        } else if (
          params.type === 'get-operating-authority-application-documents'
        ) {
          return this.OAAService.getOperatingAuthorityApplicationDocumentsService(
            params.params,
          ).pipe(
            map((data: any) => {
              return getOperatingAuthorityApplicationDocumentsDataReceived({
                params: data,
              });
            }),
            catchError((error) =>
              of(getOperatingAuthorityApplicationDocumentsDataFailed()),
            ),
          );
        } else if (params.type === 'submit-permit-request') {
          return this.OAAService.submitPermitRequestService(params.params).pipe(
            map((data: any) => {
              this.snackbarService.success(
                'Permit Request has been sent successfully',
              );
              return getOperatingAuthorityApplicationData({ params: '' });
            }),
            catchError((error) => {
              this.snackbarService.handleError(error);
              return of(submitPermitRequestFailed());
            }),
          );
        } else if (params.type === 'apply-for-reinstatement') {
          return this.OAAService.applyForReinstatementService(
            params.params,
            userData?.sessionHash,
          ).pipe(
            map((data: any) => {
              this.snackbarService.success(
                'Permit Request has been sent successfully',
              );
              return applyForReinstatementReceived();
            }),
            catchError((error) => {
              this.snackbarService.handleError(error);
              return of(applyForReinstatementFailed());
            }),
          );
        } else if (params.type === 'cancel-permit-request') {
          return this.OAAService.cancelPermitRequestService(params.params).pipe(
            map((data: any) => {
              this.snackbarService.success(
                'Permit Request has been terminated successfully',
              );
              return getOperatingAuthorityApplicationData({ params: '' });
            }),
            catchError((error) => {
              this.snackbarService.handleError(error);
              return of(cancelPermitRequestFailed());
            }),
          );
        }
        return of(noAction());
      }),
    ),
  );
}
